import { createCookieBanner } from '@lst/cookie-banner';

export default async function loadCookieBanner() {
    createCookieBanner({
        openPolicyInNewTab: true,
    });
}
